import { jsxs, jsx } from 'react/jsx-runtime';
import { addPropsToSVG } from '../helpers/add-props-to-svg.esm.js';

const _SocialYoutube = (props)=>jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            jsx("path", {
                fill: "currentColor",
                d: "M23.0195 6.1546c-.2644-1.045-1.0437-1.8678-2.0334-2.147-1.7938-.5076-8.9861-.5076-8.9861-.5076s-7.1923 0-8.9861.5075c-.9895.2793-1.769 1.1021-2.0334 2.147-.4805 1.894-.4805 5.8456-.4805 5.8456s0 3.9516.4805 5.8453c.2645 1.045 1.044 1.868 2.0334 2.1473 1.7938.5073 8.9861.5073 8.9861.5073s7.1923 0 8.9861-.5073c.9897-.2793 1.769-1.1023 2.0334-2.1473.4805-1.8937.4805-5.8453.4805-5.8453s0-3.9516-.4805-5.8455Zm-13.3196 9.4884v-7.2858l5.9755 3.6429-5.9755 3.6429Z",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            }),
            jsx("path", {
                stroke: "currentColor",
                strokeWidth: props.strokeWidth || 1.5,
                d: "M17.9996 12h.0007",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            }),
            jsx("path", {
                stroke: "currentColor",
                strokeWidth: 2,
                d: "M18 11.9999v.0001",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            })
        ]
    });
const SocialYoutube = addPropsToSVG(_SocialYoutube);

export { SocialYoutube };
